import { Box } from '@mui/material';

export default function StartHereTooltip() {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: '-12px',
          top: 0,
          backgroundColor: '#4285F4',
          color: '#fff',
          borderRadius: '8px',
          maxWidth: 260,
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.25)',
          padding: '31px 21px',
          fontSize: 16,
          lineHeight: '24px',
          fontWeight: 400,

          '&::before': {
            content: '""',
            position: 'absolute',
            left: '-24px',
            top: '38px',
            width: '24px',
            height: '20px',
            backgroundColor: '#4285F4',
            clipPath: 'polygon(100% 0, 0 50%, 100% 100%)',
            zIndex: 2,
          },

          '&::after': {
            content: '""',
            position: 'absolute',
            left: '-24px',
            top: '38px',
            width: '24px',
            height: '20px',
            backgroundColor: 'rgba(0, 0, 0, 0.25)',
            clipPath: 'polygon(100% 0, 0 50%, 100% 100%)',
            filter: 'blur(10px)',
            transform: 'translateY(4px)',
            zIndex: 1,
          },
        }}
      >
        Start here by selecting the first country for your plan.
        <br />
        Click the + button to choose the country.
      </Box>
    </Box>
  );
}
